<template>
    <v-row>
                <v-col v-for="digitalmedia in items" :key="digitalmedia.id"
                    cols="12" sm="6" md="4" xl="3" class="d-flex">
                    <v-card flat class="digital-media-card" tabindex="0"
                        @click="$emit('open', $event, digitalmedia)"
                        @mousedown.middle="$emit('open-new-tab', $event, digitalmedia)"
                        @keydown.enter.self="$emit('open', $event, digitalmedia)"
                        @keydown.space.self.prevent="$emit('open', $event, digitalmedia)">
                        <img alt="Vorschau digitale Medien" :src="imageForMedia(digitalmedia)" :alt="digitalmedia.name"
                            class="digital-media-card-image" loading="lazy" @error="$emit('image-error', $event)" />
                        <div class="pa-5 digital-media-card-content">
                            <div class="mb-3 d-flex flex-wrap ga-2">
                                <v-chip v-if="digitalmedia.type" :color="digitalmedia.type.color_code"
                                    @click.stop="$emit('filter', $event, digitalmedia.type)">
                                    {{ digitalmedia.type.name }}
                                </v-chip>
                                <v-chip v-for="tag in digitalmedia.tags || []" :key="tag.id ?? tag.name"
                                    color="primary" size="small">{{ tag.name }}</v-chip>
                            </div>
                            <h3 style="font-weight: normal">{{ digitalmedia.name }}</h3>
                            <small v-if="digitalmedia.duration" class="mb-2">
                                {{ $t('messages.digitalMediaDuration', { minutes: digitalmedia.duration }) }}
                            </small>
                            <p v-if="digitalmedia.description" class="digital-media-card-description">
                                {{ digitalmedia.description }}
                            </p>
                        </div>
                    </v-card>
                </v-col>
    </v-row>
</template>
<script>
export default {
    props: { items: { type: Array, default: () => [] }, imageForMedia: { type: Function, required: true } },
    emits: ["open", "open-new-tab", "filter", "image-error"],
};
</script>
<style scoped>
.digital-media-card {
    display: flex;
    flex-direction: column;
    width: 100%;
    border: 1px solid rgba(var(--v-theme-on-surface), 0.4);
    border-radius: 12px !important;
    overflow: hidden;
    cursor: pointer;
    background-color: rgb(var(--v-theme-light));
}
.digital-media-card:focus-visible {
    outline: 2px solid rgb(var(--v-theme-primary));
    outline-offset: 3px;
}
.digital-media-card-image {
    display: block;
    width: 100%;
    aspect-ratio: 16 / 9;
    object-fit: cover;
}
.digital-media-card-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}
.digital-media-card-description {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    overflow-wrap: anywhere;
    white-space: pre-line;
}
</style>
